var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.onlyRead)?_c('div',{ref:"onlyRead",staticClass:"only-read",on:{"click":_vm.handleClick}}):_c('div',{ref:"markdownEditor",staticClass:"editor"})])}
var staticRenderFns = []

export { render, staticRenderFns }